var map = {
	"./CarouselSimple.vue": "./vue/components/CarouselSimple.vue",
	"./CarouselTabs.vue": "./vue/components/CarouselTabs.vue",
	"./DietCarousel.vue": "./vue/components/DietCarousel.vue",
	"./FeaturesCarousel.vue": "./vue/components/FeaturesCarousel.vue",
	"./FooterComponent.vue": "./vue/components/FooterComponent.vue",
	"./HeaderComponent.vue": "./vue/components/HeaderComponent.vue",
	"./IngredientsCarousel.vue": "./vue/components/IngredientsCarousel.vue",
	"./IngredientsCarouselItem.vue": "./vue/components/IngredientsCarouselItem.vue",
	"./IngredientsModal.vue": "./vue/components/IngredientsModal.vue",
	"./Modal.vue": "./vue/components/Modal.vue",
	"./ModalWithTrigger.vue": "./vue/components/ModalWithTrigger.vue",
	"./PickyCatTabs.vue": "./vue/components/PickyCatTabs.vue",
	"./ProductCarousel.vue": "./vue/components/ProductCarousel.vue",
	"./ProductDetail.vue": "./vue/components/ProductDetail.vue",
	"./ProductListCarousel.vue": "./vue/components/ProductListCarousel.vue",
	"./RatingComponent.vue": "./vue/components/RatingComponent.vue",
	"./ReadMore.vue": "./vue/components/ReadMore.vue",
	"./SearchForm.vue": "./vue/components/SearchForm.vue",
	"./TabsOverflow.vue": "./vue/components/TabsOverflow.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./vue/components sync recursive \\.vue$/";